// extracted by css-extract-rspack-plugin
export default {"shimmerContainer":"shimmerContainer-G_J3S1","searchLights":"searchLights-uLkSR9"};